"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CookieConsent_module_1 = require("./modules/CookieConsent.module");
const loadReevooModule = () => ({
    hasRouter: false,
    modules: [(0, CookieConsent_module_1.default)()],
});
exports.default = loadReevooModule;
